<template>
  <div class="col-6 col-md filter-container prices-filter">
    <h4>{{ I18n.t('search_page.artworks_tab.filters.price.title') }}</h4>
    <p>{{ I18n.t('search_page.artworks_tab.filters.price.labels.from') }}:</p>
    <div class="input-cont">
      <input type="number" :value="priceFromValue" @blur="changePriceFromFilter($event)" @keyup.enter="loseFocus($event)">
    </div>
    <p>{{ I18n.t('search_page.artworks_tab.filters.price.labels.to') }}:</p>
    <div class="input-cont">
      <input type="number" :value="priceToValue" @blur="changePriceToFilter($event)" @keyup.enter="loseFocus($event)">
    </div>
    <ul data-filter-group>
      <li>
        <button @click="changeModesFilter(startingValue)"
                :class="{ 'filter--selected': isActive(startingValue) }"
                class="filter text-left" type="button">
          {{ I18n.t('search_page.artworks_tab.filters.price.modes.starting') }}
          <span class="icon icon-close-big"></span>
        </button>
      </li>
      <li>
        <button @click="changeModesFilter(estimationValue)"
                :class="{ 'filter--selected': isActive(estimationValue) }"
                class="filter text-left" type="button">
          {{ I18n.t('search_page.artworks_tab.filters.price.modes.estimation') }}
          <span class="icon icon-close-big"></span>
        </button>
      </li>
      <li>
        <button @click="changeModesFilter(sellingValue)"
                :class="{ 'filter--selected': isActive(sellingValue) }"
                class="filter text-left" type="button">
          {{ I18n.t('search_page.artworks_tab.filters.price.modes.selling') }}
          <span class="icon icon-close-big"></span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
  import Helpers from '@/shared/mixins/artworks_filters_helpers';
  import { mapGetters, mapActions } from 'vuex';
  import { ARTWORKS_FILTERS } from '../../../consts';

  export default {
    name: 'PriceFilterColumn',
    data() {
      return {
        startingValue: ARTWORKS_FILTERS.PRICES.VALUES.STARTING,
        estimationValue: ARTWORKS_FILTERS.PRICES.VALUES.ESTIMATION,
        sellingValue: ARTWORKS_FILTERS.PRICES.VALUES.SELLING,
        priceFromPath: ARTWORKS_FILTERS.PRICES.FROM.PATH,
        priceToPath: ARTWORKS_FILTERS.PRICES.TO.PATH,
        priceModesPath: ARTWORKS_FILTERS.PRICES.MODES.PATH,
      };
    },
    computed: {
      ...mapGetters(['filterValue']),
      priceFromValue() {
        return this.filterValue(this.priceFromPath);
      },
      priceToValue() {
        return this.filterValue(this.priceToPath);
      },
      activeValues() {
        return this.filterValue(this.priceModesPath);
      },
    },
    mixins: [Helpers],
    methods: {
      ...mapActions(['getArtworksWhenFilterIsChanging']),
      changePriceFromFilter(event) {
        this.getArtworksWhenFilterIsChanging(
          { path: this.priceFromPath, value: event.target.value },
        );
      },
      changePriceToFilter(event) {
        this.getArtworksWhenFilterIsChanging(
          { path: this.priceToPath, value: event.target.value },
        );
      },
      changeModesFilter(value) {
        const updatedValues = this.updatedActiveValues(value);
        this.getArtworksWhenFilterIsChanging(
          { path: this.priceModesPath, value: updatedValues },
        );
      },
      loseFocus(event) {
        event.target.blur(event);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/filters/price_filter_column.vue?3ba4ed4a